export default __webpack_public_path__ + "static/media/account-edit.f606bb14.svg";